
<div class="fullDiv">
    <div class="processDiv">
        <div class="spinner-border text-danger" style="width: 5rem; height: 5rem;" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>
<div id="myModal" class="Modal is-hidden is-visuallyHidden">
</div>